import axios from "axios";

// When the frontend is deployed on the same origin as the backend (path-based
// routing at /api), `REACT_APP_BACKEND_URL` can be left empty and we default to
// the current origin. Explicit value still wins — e.g. split-domain deploys.
const BACKEND_URL =
  (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL.trim()) ||
  (typeof window !== "undefined" ? window.location.origin : "");

export const API_ROOT = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_ROOT,
  withCredentials: true,
});

// Bearer fallback (some browsers/environments block third-party cookies; we
// keep the token in sessionStorage — cleared when the tab closes — so protected
// calls still work while limiting persistence surface vs. localStorage).
const TOKEN_KEY = "sso_bridge_token";

const storage = typeof window !== "undefined" ? window.sessionStorage : null;

export function setBearer(token) {
  if (!storage) return;
  if (token) {
    storage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    storage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common.Authorization;
  }
}

// hydrate on load
const stored = storage ? storage.getItem(TOKEN_KEY) : null;
if (stored) api.defaults.headers.common.Authorization = `Bearer ${stored}`;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return JSON.stringify(detail);
}
